import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import Grid from "@material-ui/core/Grid"
import Input from "../../components/Input/Input"
import Dropdown from "../../components/Dropdown/Dropdown"
import CheckboxGroup from "../../components/CheckboxGroup"
import { sanitizeAmount } from "../../helpers/sanitizeAmount"
import {
  eligibilityOptions,
  businessFunctionOptions,
  geographicEligibilityOptions,
  opportunityStatusOptions,
  findOption,
} from "../../components/Opportunity/criteriaOptions"
import styles from "./EditStyles.module.scss"
import criteriaStyles from "./OpportunityCriteriaFields.module.scss"

const CHECKBOX_GROUPS = [
  {
    name: "eligibility",
    label: "Eligibility (who can apply)",
    options: eligibilityOptions,
    columns: 2,
  },
  {
    name: "business_functions",
    label: "Business Function / Expertise",
    options: businessFunctionOptions,
    columns: 3,
  },
  {
    name: "geographic_eligibility",
    label: "Geographic Eligibility",
    options: geographicEligibilityOptions,
    columns: 3,
  },
]

const fieldError = (name, errors, touched) =>
  errors[name] && touched[name] ? errors[name] : undefined

/**
 * Opportunity fields used by the opportunity search filters that the forms
 * didn't have yet. Rendered inside the Grid container of every opportunity form.
 */
const OpportunityCriteriaFields = ({
  values,
  errors,
  touched,
  handleBlur,
  setFieldValue,
}) => {
  const change = (name, value) => {
    setFieldValue(name, value)
    handleBlur({ target: { name } })
  }

  const renderAmount = (name, label) => (
    <Grid item component="div" xs={12} md={6}>
      <Input
        className={styles.input}
        name={name}
        label={label}
        placeholder="e.g. 25000"
        inputMode="decimal"
        value={values[name]}
        onChange={(e) => change(name, sanitizeAmount(e.target.value))}
        onBlur={handleBlur}
        error={Boolean(fieldError(name, errors, touched))}
        errorMessage={fieldError(name, errors, touched)}
      />
    </Grid>
  )

  return (
    <>
      <Grid item component="div" xs={12} className={criteriaStyles.header}>
        <h5 className={criteriaStyles.heading}>Additional Details</h5>
        <p className={criteriaStyles.hint}>
          Optional. These details help the right people find your opportunity
          through the opportunity search filters.
        </p>
      </Grid>
      <Grid item component="div" xs={12} md={6}>
        <Dropdown
          border
          id="criteria_status"
          fieldStyle="gray"
          className={classNames(styles.input, styles.dropdown)}
          name="status"
          label="Opportunity Status"
          value={findOption(opportunityStatusOptions, values.status)}
          options={opportunityStatusOptions}
          onChange={(fieldName, option) => change(fieldName, option.id)}
        />
      </Grid>
      <Grid item component="div" xs={false} md={6} />
      {renderAmount("value_min", "Opportunity Value (Min $)")}
      {renderAmount("value_max", "Opportunity Value (Max $)")}
      {CHECKBOX_GROUPS.map(({ name, label, options, columns }) => (
        <Grid item component="div" xs={12} key={name}>
          <CheckboxGroup
            id={`criteria_${name}`}
            label={label}
            options={options}
            values={values[name]}
            onChange={(selected) => change(name, selected)}
            collapseAfter={null}
            columns={columns}
          />
        </Grid>
      ))}
    </>
  )
}

OpportunityCriteriaFields.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default OpportunityCriteriaFields
